import { Routes } from '@angular/router';

export const adminRoutes: Routes = [
  { path: '', redirectTo: 'impersonate', pathMatch: 'prefix' },
  { 
    path: 'impersonate', 
    pathMatch: 'full', 
    loadComponent: () => import('./impersonate/impersonate.component').then(m => m.ImpersonateComponent) 
  },
  { 
    path: 'payments',
    pathMatch: 'full', 
    loadComponent: () => import('./manual-payments/manual-payments.component').then(m => m.ManualPaymentsComponent) 
  },
  { 
    path: 'notifications', 
    pathMatch: 'full', 
    loadComponent: () => import('./notifications/notifications.component').then(m => m.NotificationsComponent) 
  },
  { 
    path: 'delete-accounts', 
    pathMatch: 'full', 
    loadComponent: () => import('./delete-accounts/delete-accounts.component').then(m => m.DeleteAccountsComponent) 
  },
  { 
    path: 'qrcodes',
    pathMatch: 'full',
    loadComponent: () => import('./qrcode-generator/qrcode-generator.component').then(m => m.QrcodeGeneratorComponent)
  },
  { 
    path: 'sms-logs', 
    pathMatch: 'full', 
    loadComponent: () => import('./sms-logs/sms-logs.component').then(m => m.SMSLogsComponent) 
  },
  { 
    path: 'marketing-modal',
    pathMatch: 'full', 
    loadComponent: () => import('./admin-marketing-modal/admin-marketing-modal.component').then(m => m.AdminMarketingModalComponent) 
  },
  {
    path: 'edit-merchant',
    pathMatch: 'full',
    loadComponent: () => import('./edit-merchant/edit-merchant.component').then(m => m.EditMerchantComponent)
  },
  { 
    path: 'marketing-modal/new', 
    pathMatch: 'full', 
    loadComponent: () => import('./admin-marketing-modal-form/admin-marketing-modal-form.component').then(m => m.AdminMarketingModalFormComponent) 
  },
  { 
    path: 'marketing-modal/:id', 
    pathMatch: 'full', 
    loadComponent: () => import('./admin-marketing-modal-form/admin-marketing-modal-form.component').then(m => m.AdminMarketingModalFormComponent) 
  },
];
